// removed by extract-text-webpack-plugin
module.exports = {"homeWrapNew":"qempo_NewHome_homeWrapNew-T1cfrf6","home":"qempo_NewHome_home-PtyJryb","imageWrap":"qempo_NewHome_imageWrap-1I-iFbH","mobile":"qempo_NewHome_mobile-H_JSKGZ","default":"qempo_NewHome_default-3ntk7gt","covid19":"qempo_NewHome_covid19-1P5-K-S","modalButton":"qempo_NewHome_modalButton-3JNZ2VP"};


//////////////////
// WEBPACK FOOTER
// ./src/modules/home/components/NewHome.scss
// module id = 2262
// module chunks = 0